import { Component } from "react";
import { translations } from "@/i18n";

/**
 * App-wide render-error fallback. Without it one page's render error unmounts
 * the whole SPA to a white screen. It must work ABOVE the providers (index.js
 * wraps everything), so it reads the language the way I18nProvider stores it
 * and the strings straight from the dictionary, and uses plain elements and
 * inline styles only. `resetKey` (the route path in App.js) clears the error
 * when the user navigates away.
 */
function lang() {
    try {
        return localStorage.getItem("ops_lang") === "en" ? "en" : "ar";
    } catch (_e) {
        return "ar";
    }
}

function tr(key) {
    const l = lang();
    return (translations[l] && translations[l][key]) || translations.en[key] || key;
}

const btn = {
    padding: "8px 16px", borderRadius: 10, border: "1px solid #d6d1c8", background: "#fff",
    color: "#2b2620", fontSize: 14, fontWeight: 600, cursor: "pointer",
};

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null, key: props.resetKey };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.resetKey !== state.key) return { error: null, key: props.resetKey };
        return null;
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("Render error caught by ErrorBoundary:", error, info?.componentStack);
    }

    render() {
        if (!this.state.error) return this.props.children;
        const l = lang();
        return (
            <div
                role="alert"
                data-testid="app-error-fallback"
                dir={l === "ar" ? "rtl" : "ltr"}
                style={{
                    minHeight: this.props.fullPage ? "100vh" : 320, display: "flex", alignItems: "center",
                    justifyContent: "center", padding: 16, background: this.props.fullPage ? "#f7f5f2" : "transparent",
                }}
            >
                <div style={{
                    maxWidth: 440, width: "100%", textAlign: "center", background: "#fff", borderRadius: 16,
                    border: "1px solid #e6e1d8", padding: "28px 20px", boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                }}>
                    <p style={{ margin: 0, fontSize: 18, fontWeight: 700, color: "#2b2620" }}>{tr("app_error_title")}</p>
                    <p style={{ margin: "8px 0 20px", fontSize: 14, lineHeight: 1.6, color: "#6b645a" }}>
                        {tr("app_error_body")}
                    </p>
                    <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
                        <button type="button" style={{ ...btn, background: "#d1802f", borderColor: "#d1802f", color: "#fff" }}
                            onClick={() => window.location.reload()}>
                            {tr("app_error_reload")}
                        </button>
                        <button type="button" style={btn} onClick={() => window.location.assign("/")}>
                            {tr("app_error_home")}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
